import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgModule, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi, withXsrfConfiguration } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { MaterialModule } from './material/material.module';
import { FooterComponent } from './components/footer/footer.component';
import { IntroductionComponent } from './components/introduction/introduction.component';
import { SafePipe } from './pipes/safe.pipe';
import { IntrobuttonComponent } from './components/introduction/introbutton/introbutton.component';
import { SelectComponent } from './components/select/select.component';
import { ComplaintFormComponent } from './components/forms/complaint-form/complaint-form.component';
import { FeedbackFormComponent } from './components/forms/feedback-form/feedback-form.component';
import { ConsentComponent } from './components/access/consent/consent.component';
import { LoggedOutComponent } from './components/access/logged-out/logged-out.component';
import { NotFoundComponent } from './components/access/not-found/not-found.component';
import { LoginComponent } from './components/login/login.component';
import { CaseListComponent } from './components/cases/case-list/case-list.component';
import { CaseDetailComponent } from './components/cases/case-detail/case-detail.component';
import { ConfirmBoxComponent } from './components/dialog/confirm-box/confirm-box.component';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { DndDirective } from './directives/dnd.directive';
import { APP_BASE_HREF, CommonModule, registerLocaleData } from '@angular/common';

import localeNb from '@angular/common/locales/nb';
import { CaseEventsListComponent } from './components/case-events-list/case-events-list.component';
import { CaseDocumentsListComponent } from './components/case-documents-list/case-documents-list.component';
import { AttachmentFilterPipe } from './pipes/attachment-filter.pipe';
import { environment } from '../environments/environment';
import { OrgnumFormControlComponent } from './components/orgnum-form-control/orgnum-form-control.component';
import { SessionTimedOutComponent } from './components/access/session-timed-out/session-timed-out.component';
import { SnackbarMessageComponent } from './components/snackbar/snackbar-message/snackbar-message.component';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { GroupByPipe } from './pipes/group-by.pipe';
import { NewContactComponent } from './components/dialog/new-contact/new-contact.component';
import { RemoveContactComponent } from './components/dialog/remove-contact/remove-contact.component';
import { ContactInvitationComponent } from './components/contact-invitation/contact-invitation.component';
import { AccessDeniedComponent } from './components/access/access-denied/access-denied.component';
import { CaseEventsComponent } from './components/case-events/case-events.component';
import { RouterModule } from '@angular/router';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { MatSpinnerOverlayComponent } from './components/mat-spinner-overlay/mat-spinner-overlay.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { FaqComponent } from './components/faq/faq.component';
import { FaqListComponent } from './components/faq/faq-list/faq-list.component';
import { StripHtmlPipe } from './pipes/strip-html.pipe';
import { ContactInvitationApproveComponent } from './components/contact-invitation/contact-invitation-approve/contact-invitation-approve/contact-invitation-approve.component';
import { AlertMessageComponent } from './components/alert-message/alert-message.component';
import { SelectLoginComponent } from './components/select-login/select-login.component';

registerLocaleData(localeNb);

@NgModule({ declarations: [
        AppComponent,
        HeaderComponent,
        FooterComponent,
        IntroductionComponent,
        SafePipe,
        StripHtmlPipe,
        AttachmentFilterPipe,
        GroupByPipe,
        IntrobuttonComponent,
        SelectComponent,
        ComplaintFormComponent,
        FeedbackFormComponent,
        ConsentComponent,
        LoggedOutComponent,
        NotFoundComponent,
        LoginComponent,
        CaseListComponent,
        CaseDetailComponent,
        ConfirmBoxComponent,
        FileUploadComponent,
        DndDirective,
        CaseEventsListComponent,
        CaseDocumentsListComponent,
        OrgnumFormControlComponent,
        SessionTimedOutComponent,
        SnackbarMessageComponent,
        NewContactComponent,
        RemoveContactComponent,
        ContactInvitationComponent,
        AccessDeniedComponent,
        CaseEventsComponent,
        MatSpinnerOverlayComponent,
        FaqComponent,
        FaqListComponent,
        ContactInvitationApproveComponent,
        AlertMessageComponent,
        SelectLoginComponent,
    ],
    exports: [
        SafePipe,
        StripHtmlPipe,
        AttachmentFilterPipe,
        GroupByPipe
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        CommonModule,
        RouterModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        MaterialModule,
        NgIdleKeepaliveModule.forRoot(),
        ServiceWorkerModule.register('/angular/ngsw-worker.js', {
            enabled: environment.production,
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        })], providers: [
        {
            provide: LOCALE_ID,
            useValue: 'nb'
        },
        // { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'standard' }},
        {
            provide: MAT_DIALOG_DEFAULT_OPTIONS,
            useValue: { hasBackdrop: true, disableClose: true }
        },
        { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 5000 } },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        },
        {
            provide: APP_BASE_HREF, useValue: '/'
        }
        // AirbrakeErrorHandler,
        // {
        //   provide: ErrorHandler,
        //   useClass: AirbrakeErrorHandler
        // },
        ,
        provideHttpClient(withInterceptorsFromDi(), withXsrfConfiguration(
            {
                cookieName: 'XSRF-TOKEN',
                headerName: 'X-XSRF-TOKEN'
            }           
        ))
    ] })
export class AppModule { }
